import { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';
import CustomModal from '../customModal';
import CustomDatePicker from '../customDatePicker';
import { formatDate } from '../../../utility/dateUtils';
import { SINGLE_DAY_SAVE_FORMAT } from '../../../constants/date';

const useStyles = makeStyles(({ spacing }) => ({
  description: {
    marginBottom: spacing(4),
  },
  label: {
    marginTop: spacing(2),
  },
}));

const EmploymentTerminationDateDialog = ({
  translations,
  isOpened,
  isUserDeactivated = false,
  initValue = null,
  minDate = undefined,
  onClose,
  onConfirm,
}) => {
  const classes = useStyles();
  const [terminationDate, setTerminationDate] = useState(initValue);

  useEffect(() => {
    setTerminationDate(initValue);
  }, [initValue]);

  const handleClose = useCallback(() => {
    setTerminationDate(null);
    onClose();
  }, [onClose]);

  const handleSave = async () => {
    await onConfirm(formatDate(terminationDate, SINGLE_DAY_SAVE_FORMAT));
    handleClose();
  };

  return (
    <CustomModal
      title={
        initValue || isUserDeactivated
          ? translations.terminationDateTitle
          : translations.title
      }
      isOpened={isOpened}
      confirmButtonLabel={
        initValue || isUserDeactivated
          ? translations.save
          : translations.deactivate
      }
      closeButtonLabel={translations.cancel}
      isConfirmDisabled={!terminationDate}
      onClose={handleClose}
      onConfirm={handleSave}
      isMedium
    >
      <div>
        <Typography className={classes.description}>
          {initValue
            ? translations.updateDescription
            : translations.description}
        </Typography>
        <CustomDatePicker
          labelClass={classes.label}
          label={translations.label}
          placeholder={translations.placegolder}
          value={terminationDate}
          disableToolbar
          minDate={minDate || undefined}
          onChange={value => setTerminationDate(value)}
          isIconOnStart
          fullWidth
          autoOk
        />
      </div>
    </CustomModal>
  );
};

EmploymentTerminationDateDialog.propTypes = {
  translations: PropTypes.object.isRequired,
  isOpened: PropTypes.bool.isRequired,
  isUserDeactivated: PropTypes.bool,
  minDate: PropTypes.string,
  initValue: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default EmploymentTerminationDateDialog;
